import React from 'react';
import { ContextList } from '../components/ContextList';
import { ContextForm } from '../components/ContextForm';

export function HomePage() {
  return (
    <div className="max-w-7xl mx-auto px-4 py-6">
      <div className="grid md:grid-cols-2 gap-6">
        <ContextForm />
        <ContextList />
      </div>
    </div>
  );
}
